import { RouteContext } from '@common/contexts';
import { ExtRouteMatch } from '@customer/components/routes';
import { last } from 'lodash';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { matchRoutes } from 'react-router-dom';

export interface IRenderWithRouteAccess {
    /**
     * The path of the route to match a user's route access to
     */
    path: string;
    /**
     * The element to render if the user has access to the route, if access is denied then null (nothing) is rendered by RenderWithRouteAccess
     */
    element: JSX.Element
}
/**
 * Use this component to Render a component if the logged in user has access to the route specified in the path attribute.
 * I.e. if you want to render a button but only if the logged in user has access to the /admin route then you would use
 *  <RenderWithRouteAccess path="/admin" element={<Button>The Button</Button>} />
 *  You can specify access for a route in the Route Tree in AppRoute and it's children via the hasAccess option on ExtRouteObject.
 */
export const RenderWithRouteAccess = observer((props: IRenderWithRouteAccess) => {
    const appRoutes = useContext(RouteContext.get());
    const matches = matchRoutes(appRoutes, props.path);
    const match = last(matches);
    const hasAccess: boolean | undefined = match && (match as ExtRouteMatch)?.route?.hasAccess;
    if (hasAccess === undefined || hasAccess === true)
        return props.element;
    return null;
});
